/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPoolingHistoryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type PoolingHistory, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { AdminRequestBuilderRequestsMetadata, type AdminRequestBuilder } from './admin/index.js';
// @ts-ignore
import { AllotmentRequestBuilderNavigationMetadata, type AllotmentRequestBuilder } from './allotment/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /PoolingHistory
 */
export interface PoolingHistoryRequestBuilder extends BaseRequestBuilder<PoolingHistoryRequestBuilder> {
    /**
     * The admin property
     */
    get admin(): AdminRequestBuilder;
    /**
     * The allotment property
     */
    get allotment(): AllotmentRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PoolingHistory[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<PoolingHistoryRequestBuilderGetQueryParameters> | undefined) : Promise<PoolingHistory[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<PoolingHistoryRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface PoolingHistoryRequestBuilderGetQueryParameters {
    showPastBookings?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const PoolingHistoryRequestBuilderUriTemplate = "{+baseurl}/PoolingHistory{?showPastBookings*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const PoolingHistoryRequestBuilderNavigationMetadata: Record<Exclude<keyof PoolingHistoryRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    admin: {
        requestsMetadata: AdminRequestBuilderRequestsMetadata,
    },
    allotment: {
        navigationMetadata: AllotmentRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const PoolingHistoryRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PoolingHistoryRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createPoolingHistoryFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
